import React, { useCallback } from 'react';

import { useMatch } from 'react-router-dom';

import { IBaseProps } from '@rbi-ctg/frontend';

import StyledLink from './styled-link';

interface INavLinkProps extends IBaseProps {
  to: string;
  requiresExactMatch?: boolean;
  onClick?: () => void;
  className?: string;
}

export const NavLink = ({
  requiresExactMatch,
  to,
  children,
  'data-testid': dataQaId,
  onClick,
  className = ''
}: INavLinkProps) => {
  const onClickHandler = useCallback(() => {
    if (onClick) {
      onClick();
    }
  }, [onClick]);
  const pathToMatch = requiresExactMatch ? to : `${to}/*`;
  const pathMatch = useMatch(pathToMatch);

  const activeClassName = pathMatch ? 'active' : '';

  return (
    <StyledLink
      to={to}
      onClick={onClickHandler}
      className={`${className} ${activeClassName}`}
      data-testid={dataQaId}
    >
      {children}
    </StyledLink>
  );
};

export const iconSize = 25;
